module.exports = __webpack_public_path__ + "img/major-03-stars-glow-and-bars.4ea6a277.svg";